import { createMuiTheme } from '@material-ui/core'

const htmlFontSize = 10;
const pxToRem = size => `${(size / htmlFontSize)}rem`;

const paletteTextPrimary = 'rgba(0, 30, 50, 0.65)';
const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      'Montserrat',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(','),
    useNextVariants: true,
    fontWeight: 500,
    htmlFontSize: htmlFontSize,
    fontSize: 13,
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    title: {
      fontSize: 18
    },
    button: {
      fontWeight: 500,
      fontSize: pxToRem(13)
    },
    h2: {
      fontSize: pxToRem(36),
      fontWeight: 500
    },
    h3: {
      fontSize: pxToRem(24),
      fontWeight: 500
    },
    h4: {
      fontSize: pxToRem(20),
      fontWeight: 500,
      lineHeight: 1.3
    },
    h5: {
      fontSize: pxToRem(18),
      fontWeight: 500,
      lineHeight: 1.8
    },
    h6: {
      fontSize: pxToRem(16),
      fontWeight: 500
    },
    subtitle1: {
      fontSize: pxToRem(15)
    },
    body1: {
      fontSize: pxToRem(15)
    },
    body2: {
      // fontSize: 13,
    },
    caption: {
      fontSize: pxToRem(12)
    }
  },
  shadows: [
    'none',
    '0px 0px 3px 0px rgba(0, 0, 0, 0.15),0px 0px 1px 0px rgba(0, 0, 0, 0.12),0px 0px 1px -1px rgba(0, 0, 0, 0.10)',
    '0px 0px 5px 0px rgba(0, 0, 0, 0.15),0px 0px 2px 0px rgba(0, 0, 0, 0.12),0px 0px 1px -2px rgba(0, 0, 0, 0.10)',
    '0px 0px 8px 0px rgba(0, 0, 0, 0.15),0px 0px 4px 0px rgba(0, 0, 0, 0.12),0px 0px 3px -2px rgba(0, 0, 0, 0.10)',
    '0px 0px 4px -1px rgba(0, 0, 0, 0.15),0px 0px 5px 0px rgba(0, 0, 0, 0.12),0px 0px 10px 0px rgba(0, 0, 0, 0.10)',
    '0px 3px 5px -1px rgba(0, 0, 0, 0.15),0px 5px 8px 0px rgba(0, 0, 0, 0.12),0px 1px 14px 0px rgba(0, 0, 0, 0.10)',
    '0px 3px 5px -1px rgba(0, 0, 0, 0.15),0px 6px 10px 0px rgba(0, 0, 0, 0.12),0px 1px 18px 0px rgba(0, 0, 0, 0.10)',
    '0px 4px 5px -2px rgba(0, 0, 0, 0.15),0px 7px 10px 1px rgba(0, 0, 0, 0.12),0px 2px 16px 1px rgba(0, 0, 0, 0.10)',
    '0px 5px 5px -3px rgba(0, 0, 0, 0.15),0px 8px 10px 1px rgba(0, 0, 0, 0.12),0px 3px 14px 2px rgba(0, 0, 0, 0.10)',
    '0px 5px 6px -3px rgba(0, 0, 0, 0.15),0px 9px 12px 1px rgba(0, 0, 0, 0.12),0px 3px 16px 2px rgba(0, 0, 0, 0.10)',
    '0px 6px 6px -3px rgba(0, 0, 0, 0.15),0px 10px 14px 1px rgba(0, 0, 0, 0.12),0px 4px 18px 3px rgba(0, 0, 0, 0.10)',
    '0px 6px 7px -4px rgba(0, 0, 0, 0.15),0px 11px 15px 1px rgba(0, 0, 0, 0.12),0px 4px 20px 3px rgba(0, 0, 0, 0.10)',
    '0px 7px 8px -4px rgba(0, 0, 0, 0.15),0px 12px 17px 2px rgba(0, 0, 0, 0.12),0px 5px 22px 4px rgba(0, 0, 0, 0.10)',
    '0px 7px 8px -4px rgba(0, 0, 0, 0.15),0px 13px 19px 2px rgba(0, 0, 0, 0.12),0px 5px 24px 4px rgba(0, 0, 0, 0.10)',
    '0px 7px 9px -4px rgba(0, 0, 0, 0.15),0px 14px 21px 2px rgba(0, 0, 0, 0.12),0px 5px 26px 4px rgba(0, 0, 0, 0.10)',
    '0px 8px 9px -5px rgba(0, 0, 0, 0.15),0px 15px 22px 2px rgba(0, 0, 0, 0.12),0px 6px 28px 5px rgba(0, 0, 0, 0.10)',
    '0px 8px 10px -5px rgba(0, 0, 0, 0.15),0px 16px 24px 2px rgba(0, 0, 0, 0.12),0px 6px 30px 5px rgba(0, 0, 0, 0.10)',
    '0px 8px 11px -5px rgba(0, 0, 0, 0.15),0px 17px 26px 2px rgba(0, 0, 0, 0.12),0px 6px 32px 5px rgba(0, 0, 0, 0.10)',
    '0px 9px 11px -5px rgba(0, 0, 0, 0.15),0px 18px 28px 2px rgba(0, 0, 0, 0.12),0px 7px 34px 6px rgba(0, 0, 0, 0.10)',
    '0px 9px 12px -6px rgba(0, 0, 0, 0.15),0px 19px 29px 2px rgba(0, 0, 0, 0.12),0px 7px 36px 6px rgba(0, 0, 0, 0.10)',
    '0px 10px 13px -6px rgba(0, 0, 0, 0.15),0px 20px 31px 3px rgba(0, 0, 0, 0.12),0px 8px 38px 7px rgba(0, 0, 0, 0.10)',
    '0px 10px 13px -6px rgba(0, 0, 0, 0.15),0px 21px 33px 3px rgba(0, 0, 0, 0.12),0px 8px 40px 7px rgba(0, 0, 0, 0.10)',
    '0px 10px 14px -6px rgba(0, 0, 0, 0.15),0px 22px 35px 3px rgba(0, 0, 0, 0.12),0px 8px 42px 7px rgba(0, 0, 0, 0.10)',
    '0px 11px 14px -7px rgba(0, 0, 0, 0.15),0px 23px 36px 3px rgba(0, 0, 0, 0.12),0px 9px 44px 8px rgba(0, 0, 0, 0.10)',
    '0px 11px 15px -7px rgba(0, 0, 0, 0.15),0px 24px 38px 3px rgba(0, 0, 0, 0.12),0px 9px 46px 8px rgba(0, 0, 0, 0.10)'
  ],
  palette: {
    background: {
      default: '#eceff1',
      paper: '#fff'
    },
    primary: {
      // light: '#4cc7ff', // unused
      main: '#29B5F5',
      dark: '#0287D0',
      contrastText: '#fff'
    },
    secondary: {
      light: '#91979f',
      main: '#6b7c82',
      dark: '#546E7A',
      contrastText: '#fff'
    },
    good: {
      main: '#4dd5c7',
      dark: '#41c3b0'
    },
    warning: {
      main: '#FDC62B',
      dark: '#e09d00'
    },
    danger: {
      main: '#E75656',
      dark: '#BF3D3D'
    },
    error: {
      main: '#E75656'
    },
    default: {
      main: '#6b7c82',
      dark: '#546E7A'
    },
    cooling: {
      main: '#29B5F5',
      dark: '#0287D0',
      contrastText: '#fff'
    },
    heating: {
      main: '#ff6f48',
      dark: '#cc583b'
    },
    loading: {
      main: '#ddd'
    },
    text: {
      primary: paletteTextPrimary,
      secondary: 'rgba(0, 0, 20, 0.50)'
    }
  },
  overrides: {
    MuiButton: { // Name of the component / style sheet
      contained: { // Name of the rule
        boxShadow: 'none',
        '&$focusVisible': {
          boxShadow: 'none'
        },
        '&:active': {
          boxShadow: 'none'
        }
      }
    },
    MuiIconButton: {
      root: {
        color: paletteTextPrimary
      }
    },
    MuiListItemIcon: {
      root: {
        color: paletteTextPrimary
      }
    },
    MuiDialog: {
      paper: {
        margin: 16
      }
    },
    MuiInput: {
      root: {
        border: '1px solid #eceff1',
        // color: '#6b7c82',
        borderRadius: '2px',
        '& > input': {
          padding: '8px',
          fontSize: '100%'
        }
      },
      formControl: {
        'label + &': {
          marginTop: '8px'
        }
      }
    },
    MuiInputBase: {
      inputType: {
        height: null
      }
    },
    MuiInputLabel: {
      root: {
        textTransform: 'uppercase',
        fontSize: '1.2rem'
      },
      formControl: {
        position: 'static',
        transform: 'none'
      },
      shrink: {
        transform: 'none'
      }
    },
    MuiInputAdornment: {
      positionStart: {
        marginLeft: 8
      },
      positionEnd: {
        marginRight: 8
      }
    },
    MuiFormHelperText: {
      root: {
        marginTop: 0,
        alignSelf: 'flex-end',
        position: 'absolute',
        width: '100%',
        textAlign: 'right'
      }
    },
    MuiSelect: {
      selectMenu: {
        paddingLeft: 8
      }
    },
    MuiCheckbox: {
      root: {}
    },
    MuiAppBar: {
      colorDefault: {
        backgroundColor: 'white',
        color: paletteTextPrimary
      }
    },
    MuiAvatar: {
      root: {
        fontSize: 16 // TODO check unit
      }
    }
  },
  props: {
    MuiInput: {
      disableUnderline: true
    },
    MuiInputLabel: {
      shrink: true
    }
  }
});

export default theme
